// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","561":"ArticleShow"}[chunkId] + "." + {"443":"8ae86521","561":"92821da8"}[chunkId] + ".css";
};